import React from "react";
import { Tabs } from "antd";

const AlsoIncomesTabUi = ({ tabId, setTabId, counts }) => {
  const items = [
    {
      label: "All Documents",
      key: "all_documents",
      count: counts.all_documents,
    },
    {
      label: "Require Review",
      key: "require_review",
      count: counts.require_review,
    },
    { label: "Pending", key: "pending", count: counts.pending },
  ];

  return (
    <Tabs
      className="mx-2 text-base"
      popupClassName="mb-0"
      tabBarStyle={{
        marginBottom: 0,
      }}
      activeKey={tabId}
      defaultActiveKey={tabId}
      items={items.map((item) => ({
        label: (
          <div style={{ display: "flex", alignItems: "center" }}>
            {item.label}
            <div
              className="text-xs text-center ml-1"
              style={{
                backgroundColor: tabId === item.key ? "#E6F7FF" : "#E0E0E0",
                color: tabId === item.key ? "#03B0F7" : "#00000073",
                padding: "0px 9px",
                borderRadius: 100,
              }}
            >
              {item.count}
            </div>
          </div>
        ),
        key: item.key,
      }))}
      onChange={(value) => {
        setTabId(value);
      }}
    />
  );
};

export default AlsoIncomesTabUi;
